export default __webpack_public_path__ + "static/media/stDOT.63d27f89.svg";